import './Main.css'
import React, { ChangeEvent, FocusEvent, useEffect, useState, useMemo } from "react";
import { Link, useLocation, useSearchParams, useParams, useNavigate } from 'react-router-dom';
import loan from '../Images/loan.png'
import memberShip from '../Images/memberShip.png'
import travel from '../Images/travel.png'
import Insurance from '../Images/Insurance.png'
import card from '../Images/card.png'
import payment from '../Images/payment.png'
import contact from '../Images/contact.jpg'
import http from "../Services/httpService";
import service from "../Services/services";
import config from "../config.json";
import { toast } from "react-toastify";
import ConfirmDialog from './ConfirmDialog'
import loanLogo from '../Images/loanLogo.png'
export default function Main() {
  let navigate = useNavigate();
  const [showLoading, setShowLoading] = useState(0)
  const [isLoading, setIsLoading] = useState(false)

  const [dataUser, setDataUser] = useState({ id: 0, name: "", family: "" })
  const loadData = async () => {
    setIsLoading(true);
    await service.OzveGet()
      .then(({ data }) => {
        setIsLoading(false);
        if (data.errorCode != 0) {
          toast.error(data.message, { theme: "colored" });
          return
        }
        setDataUser(data.payload);
        setShowLoading(0);
      })
      .catch(err => {
        setIsLoading(false);
      });
  }


  const [ozveSetting, setOzveSetting] = useState({ vam: "" })
  const [isLoadingSetting, setIsLoadingSetting] = useState(false)
  const getSetting = async () => {
    setIsLoadingSetting(true);
    await service.SettingGet()
      .then(({ data }) => {
        setIsLoadingSetting(false);
        /*if (data.errorCode != 0) {
          toast.error(data.message, { theme: "colored" });
          return
        }*/
        setOzveSetting(data);
        //method();
        setShowModal(true);
      })
      .catch(err => {
        setIsLoadingSetting(false);
      });
  }


  useEffect(() => {
    const jwt = http.getLocalJwt();
    if (!jwt || jwt == "") {
      navigate('/login');
      return;
    }
    loadData()
  }, [])


  const logout = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    http.logout();
    http.goLogin();
  }

  const [mode, setMode] = useState("")
  const [showModal, setShowModal] = useState(false);
  const [inRequestLoan, setInRequestLoan] = useState(false)
  const sendRequestLoan = async () => {
    setInRequestLoan(true);
    await service.RequestLoan()
      .then(({ data }) => {
        setInRequestLoan(false);
        if (data.errorCode != 0) {
          toast.error(data.message, { theme: "colored" });
          return
        }
        setShowModal(false);
        toast.dark('درخواست شما ثبت شد')
      })
      .catch(err => {
        setInRequestLoan(false);
      });
  }
  const sendRequestTravel = async () => {
    setInRequestLoan(true);
    await service.RequestTravel()
      .then(({ data }) => {
        setInRequestLoan(false);
        if (data.errorCode != 0) {
          toast.error(data.message, { theme: "colored" });
          return
        }
        setShowModal(false);
        toast.dark('درخواست شما ثبت شد')
      })
      .catch(err => {
        setInRequestLoan(false);
      });
  }

  const doPayment = async (mode) => {
    setInRequestLoan(true);
    await service.Payment(mode)
      .then(({ data }) => {
        setInRequestLoan(false);
        if (data.errorCode != 0) {
          toast.error(data.message, { theme: "colored" });
          return
        }
        //toast.dark('درخواست شما ثبت شد')
        toast.dark('لطفا تا انتقال به درگاه بانک شکیبا باشید');
        window.location = data.payload;
        //window.open(data.payload,'_self');//'_blank');
      })
      .catch(err => {
        setInRequestLoan(false);
      });
  }

  const [showInsuranceCancel, setShowInsuranceCancel] = useState(false)
  const [inInsuranceCancel, setInInsuranceCancel] = useState(false)
  const doInsuranceCancel = async (w) => {
    setInInsuranceCancel(true);
    await service.RequestInsuranceCancel()
      .then(({ data }) => {
        setInInsuranceCancel(false);
        if (data.errorCode != 0) {
          toast.error(data.message, { theme: "colored" });
          return
        }
        toast.dark('درخواست شما ثبت شد');
      })
      .catch(err => {
        setInInsuranceCancel(false);
      });
  }
  return (
    <>
      <ConfirmDialog
        show={showInsuranceCancel}
        title={`ثبت در خواست انصراف از بیمه تکمیلی`}
        handleDo={doInsuranceCancel}
        handleCancel={(e) => setShowInsuranceCancel(false)}
        isBusy={inInsuranceCancel}
      >
        <div className='row mt-3'>
          <div className='col'>
            <div className='alert alert-danger'>
              آیا از انصراف بیمه تکمیلی اطمینان دارید؟
            </div>
          </div>
        </div>
      </ConfirmDialog>
      <ConfirmDialog
        show={showModal}
        size='xl'
        title={`ثبت در خواست `}
        handleDo={() => {
          mode == "lean" ? sendRequestLoan() : sendRequestTravel()
        }
        }
        handleCancel={(e) => setShowModal(false)}
        isBusy={inRequestLoan}
      >
        <div className='row mt-3'>
          {<div className='col-auto'>
            <img src={mode == "lean" ? loanLogo : travel} />
          </div>}
          <div className='col fs-3'>
            {mode == "lean" ? ozveSetting.vam : ozveSetting.safar}
          </div>
        </div>
      </ConfirmDialog>

      <div className="row" id="rowProfile">
        <div className="col d-flex align-items-end justify-content-end">
          {showLoading != 1 &&
            <img
              src={`${config.apiUrl}/picture/${dataUser.id}.jpg?${new Date().getTime()}`}
              // src={`${config.apiUrl}/api/kanon/WebOzve/GetPic?id=${dataUser.id}&${new Date().getTime()}`}
              className="img-fluid"
              alt=" "
              id="picProfile"
              onLoad={(e) => { setShowLoading(2) }}
              onError={(e) => { console.log('error', e); setShowLoading(1) }}
            />
          }
          {showLoading == 0 || showLoading == 1 &&
            <img
              src={contact}
              className="img-fluid"
              alt=" "
              id="picProfile"
            // onLoad={(e) => { setShowLoading(false) }}
            />
          }

        </div>
        <div className="col">
          <div className='row mt-3 pb-2'>
            <div className='col   '>
              {dataUser.name + " " + dataUser.family}
            </div>
          </div>
          <div className='row'>
            <div className='col align-items-center'>
              <div className=' d-flex text-secondary fs-6 mt--5'>تاریخ اعتبار</div>
              <div className='  fw-bold fs-5 text-danger'>{dataUser.cardExpire}  </div>
            </div>
          </div>
          <div className='row'>
            <div className='col'>
              <div className='d-flex text-secondary fs-6 mt--5'>کد ملی</div>
              <span className='  fw-bold fs-5'>{dataUser.codeMeli}  </span>
            </div>
          </div>

          <div className='row '>
            <div className='col'>
              <Link to="/" onClick={logout}>خروج</Link>
              {isLoading &&
                <div className="spinner-border spinner-border-sm" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>}
            </div>
          </div>

        </div>
      </div>
      <div className="row mt-2 mx-auto">

        <div className='col d-flex justify-content-end'>
          <span className='  text-secondary fs-6 mt--5 me-1'>شماره مستمری</span>
          <div className='d-flex fw-bold fs-6'>{dataUser.mostamariCode}    </div>
        </div>


        <div className='col d-flex '>
          <span className='  text-secondary fs-6 mt--5 me-1'>شماره عضویت</span>
          <div className='d-flex fw-bold fs-6'>{dataUser.number}    </div>
        </div>
      </div>
      <div className='row mt-3 mx-auto  justify-content-center'>
        <Link
          to="/personData"
          className='col-3 mb-3 text-dark text-decoration-none p-3 mx-2 shadow bg-light rounded'>
          <div className="row">
            <div className='col p-0 d-flex align-items-center justify-content-center'>
              <img src={memberShip} className='thumbnail img-responsive imgMenu' />
            </div>
          </div>
          <div className="row">
            <div className='col p-0 d-flex align-items-center justify-content-center'>
              مشخصات شما
            </div>
          </div>
        </Link>
        <Link
          to="/"
          onClick={e => {
            e.preventDefault();
            e.stopPropagation();
            if (isLoadingSetting)
              return;
            setMode("lean")
            getSetting()
          }}
          className='col-3 mb-3 text-dark text-decoration-none p-3 mx-2 shadow bg-light rounded'>
          <div className="row">
            <div className='col p-0 d-flex align-items-center justify-content-center'>
              <img src={loan} className='thumbnail img-responsive imgMenu' />
            </div>
          </div>
          <div className="row">
            <div className='col p-0 d-flex align-items-center justify-content-center'>
              درخواست وام
              {isLoadingSetting &&
                <div className="spinner-border spinner-border-sm" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>}
            </div>
          </div>
        </Link>
        <Link
          to="/"
          onClick={e => {
            e.preventDefault();
            e.stopPropagation();
            if (isLoadingSetting)
              return;
            setMode("travel")
            getSetting()
          }} className='col-3 mb-3 text-dark text-decoration-none p-3 mx-2 shadow bg-light rounded'>
          <div className="row">
            <div className='col p-0 d-flex align-items-center justify-content-center'>
              <img src={travel} className='thumbnail img-responsive imgMenu' />
            </div>
          </div>
          <div className="row">
            <div className='col p-0 d-flex align-items-center justify-content-center'>
              ثبت نام سفر
            </div>
          </div>
        </Link>
        <a
          href="https://kbtoh.ir"
          className='col-3 mb-3 text-dark text-decoration-none p-3 mx-2 shadow bg-light rounded'>
          <div className="row">
            <div className='col p-0 d-flex align-items-center justify-content-center'>
              <img src={Insurance} className='thumbnail img-responsive imgMenu' />
            </div>
          </div>
          <div className="row">
            <div className='col mb-3 p-0 d-flex align-items-center justify-content-center'>
              بیمه تکمیلی
            </div>
          </div>
        </a>
        {/*<Link
          onClick={e => {
            e.preventDefault();
            e.stopPropagation()
            setShowInsuranceCancel(true)
          }}
          to="/sendMedia"*/}
        <a
          href="https://kbtoh.ir"
          className='col-3 mb-3 text-dark text-decoration-none p-3 mx-2 shadow bg-light rounded'>
          <div className="row">
            <div className='col p-0 d-flex align-items-center justify-content-center'>
              <img src={Insurance} className='thumbnail img-responsive imgMenu' />
            </div>
          </div>
          <div className="row">
            <div className='col p-0 d-flex align-items-center justify-content-center'>
              انصراف بیمه تکمیلی
            </div>
          </div>
        </a>
        <Link
          onClick={e => {
            e.preventDefault();
            e.stopPropagation()
            doPayment(1);
          }}
          to="/sendMedia"
          className='col-3 mb-3 text-dark text-decoration-none p-3 mx-2 shadow bg-light rounded'>

          <div className="row">
            <div className='col p-0 d-flex align-items-center justify-content-center'>
              <img src={payment} className='thumbnail img-responsive imgMenu' />
            </div>
          </div>
          <div className="row">
            <div className='col p-0 d-flex align-items-center justify-content-center'>
              پرداخت حق عضویت
            </div>
          </div>
        </Link>

      </div>
    </>
  );
}

